import { render, staticRenderFns } from "./HeaderActionButton.vue?vue&type=template&id=31dbeee5&scoped=true&"
import script from "./HeaderActionButton.vue?vue&type=script&lang=js&"
export * from "./HeaderActionButton.vue?vue&type=script&lang=js&"
import style0 from "./HeaderActionButton.vue?vue&type=style&index=0&id=31dbeee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dbeee5",
  null
  
)

export default component.exports